import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const CookieConsent = () => {
    const [show, setShow] = useState(false);
    const {t} = useTranslation();
    const navigate = useNavigate();

    useEffect(() => {
        const consent = localStorage.getItem('cookieConsent');
        if (!consent) {
            setShow(true);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem('cookieConsent', 'true');
        setShow(false);
    };

    const handleClickPrivacy = (e) => {
        e.preventDefault();
        navigate('/privacy');
      }

    if (!show) return null;

    return (
        <div className="cookie-consent">
            <p>
            {t("cookies_consent.text1")}
                <a href="javascript:void();" onClick={(e) => handleClickPrivacy(e)}> {t("cookies_consent.text2")}</a>
            </p>
            <button onClick={handleAccept}>
            {t("cookies_consent.button_text")}
            </button>
        </div>
    );
};

export default CookieConsent;
